import { AlignJustify } from "lucide-react";
import { EllipsisVertical } from "lucide-react";
import { CircleAlert } from "lucide-react";
import SideBar from "./SideBar.tsx";

interface INavBar {
  children?: any;
  isVisible: boolean;
  SetState: any;
}

export default function NavBar({ children, SetState, isVisible }: INavBar) {
  return (
    <>
      <div className="w-full h-10 bg-green-500 text-black justify-between items-center flex pt-7 pr-10 pl-10 pb-7">
        <AlignJustify
          onClick={() => {
            SetState(true);
          }}
        />
        <h1>Группа</h1>
        <CircleAlert />
        <EllipsisVertical />
      </div>
      {isVisible && <SideBar SetState={SetState} />}
      {children}
    </>
  );
}
